import { QBAssetListCardIconBarProps } from '../QBAssetListCardIconBar/types'
import { QBAssetListCardQuestionGroupsContentProps } from './types'
import { styles } from './styles'
import { FText, FUseColor } from '@fantaskticedtechlimited/fui-complib'
import { FFontTypes } from '@fantaskticedtechlimited/fui-fontlib'
import QBAssetListCardIconBar from '../QBAssetListCardIconBar'

export const QBAssetListCardQuestionGroupsContent = (
    props: QBAssetListCardQuestionGroupsContentProps
) => {
    const data = props.data
    const questionData = data.questions
    const iconBarProps: Partial<QBAssetListCardIconBarProps> = {
        questionGroupsNumber: questionData.length,
    }

    return (
        <div className={styles.CardContent_Container} onClick={props.onClick}>
            <FText
                font={FFontTypes.Large_Text()}
                color={FUseColor({ colorName: 'Grey' })}
            >
                {data.orderSequence}
            </FText>
            <FText
                font={FFontTypes.Large_Text()}
                maxRows={2}
                overflowHidden
                style={{ flex: 1 }}
            >
                {data.name}
            </FText>
            <QBAssetListCardIconBar {...iconBarProps} />
        </div>
    )
}
